import axios from "axios";
const { VUE_APP_API_URL, VUE_APP_TOUR_API_URL, VUE_APP_VT_API_URL } =
  process.env;

const fetchLocalToursByCityCode = async (cityCode) => {
  try {
    const res = await axios.get(
      `${VUE_APP_API_URL}/api/localtourv2/uk/${cityCode}`
    );
    if (res && res.data) {
      return res.data;
    }
  } catch (err) {
    return null;
  }
};

const fetchGAdvData = async (tourCode) => {
  try {
    const res = await axios.get(
      `${VUE_APP_TOUR_API_URL}/gadventure/tour_dossiers/${tourCode}`
    );
    if (res && res.data) {
      return res.data;
    }
  } catch (err) {
    return null;
  }
};

const fetchIntrepidData = async (product_code, season) => {
  try {
    const res = await axios.get(
      `${VUE_APP_API_URL}/adventure-tour/intrepid/trip_data/${product_code}/${season}`
    );
    if (res && res.data) {
      return res.data;
    }
  } catch (err) {
    return null;
  }
};

const fetchExodusData = async (holiday_code) => {
  try {
    const res = await axios.get(
      `${VUE_APP_API_URL}/adventure-tour/exodus/holiday_data/${holiday_code}`
    );
    if (res && res.data) {
      return res;
    }
  } catch (err) {
    return null;
  }
};

const fetchExploreData = async (product_code, departure_date) => {
  try {
    const res = await axios.get(
      `${VUE_APP_TOUR_API_URL}/adventure-tour/explore/trip_data/${product_code}/${departure_date}`
    );
    if (res && res.data) {
      return res.data;
    }
  } catch (err) {
    return null;
  }
};

const fetchTrafalgarData = async (product_code, departure_date) => {
  try {
    const res = await axios.get(
      `${VUE_APP_TOUR_API_URL}/adventure-tour/trafalgar/trip_data/${product_code}/${departure_date}`
    );
    if (res && res.data) {
      return res.data;
    }
  } catch (err) {
    return null;
  }
};

const fetchAATKingsData = async (product_code, departure_date) => {
  try {
    const res = await axios.get(
      `${VUE_APP_TOUR_API_URL}/adventure-tour/aatkings/trip_data/${product_code}/${departure_date}`
    );
    if (res && res.data) {
      return res.data;
    }
  } catch (err) {
    return null;
  }
};

const postTouringPDF = async (fileName, token, bookno, filePath) => {
  try {
    const res = await axios.post(
      `${VUE_APP_VT_API_URL}/vt-api/viewtrail/pdf`,
      {
        "filename": fileName,
        "file_location": filePath,
        "partial_location": true,
        "bookno": bookno,
        "token": token
      },
      {
        responseType: "blob",
      }
    );
    if (res && res.data) {
      return res.data;
    }
  } catch (err) {
    return null;
  }

}

export {
  fetchLocalToursByCityCode,
  fetchGAdvData,
  fetchIntrepidData,
  fetchExodusData,
  fetchExploreData,
  fetchTrafalgarData,
  fetchAATKingsData,
  postTouringPDF
};
